// service.js
import DataService from '../dataService';
import api from '../api';

const getEOITenders = async page => {
	try {
		const response = await DataService.get(
			`${api.EOIApi}limit_start=${page}&order_by=last_date%20desc`
		);
		return response.data;
	} catch (error) {
		console.error('API Error:', error);
		throw error?.message || 'An error occurred while fetching EOI';
	}
};
const getTotalPages = async () => {
	try {
		const response = await DataService.get(`${api.TotalPagesApi}`);
		return response.data;
	} catch (error) {
		console.error('API Error:', error);
		throw error?.message || 'An error occurred while fetching TotalPages';
	}
};

export { getEOITenders, getTotalPages };
